import { FieldInputProps } from 'react-final-form'

/**
 * @description if is an object return input.value.value or input.value
 */
export const getValue = (input: FieldInputProps<string, HTMLElement>): boolean => {
  if (input.value === 'true' || !!input.value) {
    return true
  }
  if (input.value === 'false') {
    return false
  }
  return false
}
